import type { AttendanceHistory } from "./use-staff-turnover";

export type AttendanceHistoryGroup = {
  key: string;
  event: AttendanceHistory;
  changes: AttendanceHistory[];
  reasons: string[];
  evidence: AttendanceHistory[];
};

// A save can produce one edit record and several employee mark records.
// Present those as one amendment, retaining each actual transition and reason.
export function attendanceHistoryGroups(history: AttendanceHistory[] = []): AttendanceHistoryGroup[] {
  const groups = new Map<string, AttendanceHistoryGroup>();
  history.forEach((event, index) => {
    if (event.kind === "created") return;
    const transition = !!event.fromStatus && !!event.toStatus && event.fromStatus !== event.toStatus;
    const changedDetails = event.evidence?.before !== undefined && event.evidence?.after !== undefined &&
      JSON.stringify(event.evidence.before) !== JSON.stringify(event.evidence.after);
    if (event.kind === "mark" && (!event.fromStatus || (!transition && !changedDetails))) return;
    const timestamp = event.createdAt || event.at;
    const date = timestamp ? new Date(timestamp) : null;
    const time = date && !Number.isNaN(date.getTime()) ? String(date.getTime()) : event.id || String(index);
    const actor = event.actorId || event.actorName || event.changedBy || event.by || "";
    const key = `${time}|${actor}|${event.kind === "late_sick_decision" ? event.employeeId || "decision" : "amendment"}`;
    let group = groups.get(key);
    if (!group) {
      group = { key, event, changes: [], reasons: [], evidence: [] };
      groups.set(key, group);
    }
    if (transition || changedDetails || event.kind === "late_sick_decision") {
      const duplicate = !!event.id && group.changes.some(change => change.id === event.id);
      if (!duplicate) group.changes.push(event);
    }
    const reason = (event.reason || event.why || "").trim();
    if (reason && !group.reasons.includes(reason)) group.reasons.push(reason);
    if (event.id && event.evidence?.photoKey && !group.evidence.some(item => item.id === event.id)) group.evidence.push(event);
  });
  return [...groups.values()].filter(group => group.changes.length || group.reasons.length || group.evidence.length);
}
